export function OarAmicci() {
  return (
    <svg
      width="312.72833"
      height="650"
      viewBox="0 0 82.742702 171.97917"
      version="1.1"
      id="amici"
    >
      <defs id="defs1" />
      <g id="layer1" transform="translate(0.19270325)">
        <rect
          fill="#008fd5"
          id="rect1"
          width="82.742706"
          height="171.97917"
          x="-0.19270325"
          y="1.527482e-14"
        />
      </g>
    </svg>
  );
}
